export default "__VITE_ASSET__3da95975__"